import AppointmentContext from "context/AppointmentContext";
import CompanyOfficialsTab from "./CompanyOfficialsTab";

const Appointment = (props) => {
  return (
    <AppointmentContext.Provider
      value={{
        appointmentDesignation: props.selectedDesignation,
        changeType: props.changeType,
        trxRef: props.trxRef,
      }}
    >
      <div>
        <CompanyOfficialsTab
          selectedOfficial={props.official}
          setShowProceedButton={props.setShowProceedButton}
          showCompanyOfficialsForm={props.showCompanyOfficialsForm}
          setShowCompanyOfficialsForm={props.setShowCompanyOfficialsForm}
        />
      </div>
    </AppointmentContext.Provider>
  );
};

export default Appointment;
